import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.scss';

const Footer = () => {
  const location = useLocation();

  // Handle partner link clicks to ensure scrolling works
  const handlePartnerLinkClick = (e, hash) => {
    // If already on about page, force scroll
    if (location.pathname === '/about' && window.location.hash === hash) {
      e.preventDefault();
      // Force hash change to trigger scroll
      window.location.hash = '';
      setTimeout(() => {
        window.location.hash = hash;
        // Trigger scroll manually
        const elementId = hash.substring(1);
        const element = document.getElementById(elementId);
        if (element) {
          const isMobile = window.innerWidth <= 768;
          const headerOffset = isMobile ? 130 : 110;
          const elementPosition = element.getBoundingClientRect().top;
          const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
          const offsetPosition = Math.max(0, currentScrollY + elementPosition - headerOffset);
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }, 10);
    }
    // Otherwise, let React Router handle navigation normally
  };
  
  // List of valid routes
  const validRoutes = [
    '/',
    '/home-v1',
    '/home-v2',
    '/about',
    '/methodology',
    '/contact-us',
    '/privacy-policy'
  ];
  
  // Check if current path is a valid route or starts with valid route patterns
  const isValidRoute = validRoutes.includes(location.pathname) ||
    location.pathname.startsWith('/country-energy-profile') ||
    location.pathname.startsWith('/impact-insights') ||
    location.pathname.startsWith('/projects') ||
    location.pathname.startsWith('/blog/');
  
  // If it's not a valid route, it's the 404 page
  const isNotFoundPage = !isValidRoute;

  return (
    <footer className={`footer ${isNotFoundPage ? 'footer--no-margin' : ''}`}>
      <div className="container-fuild">
        {/* Top Section */}
        <div className="footer-top">
          <div className="footer-left">
            <div className="footer-map-section">
              <img 
                src="/images/footer/africa-map.svg" 
                alt="Map of Africa graphic used in the footer" 
                className="footer-africa-map"
              />
              <div className="footer-map-content">
                <h3 className="footer-title">Africa SDG 7 Investment & Progress Tracker</h3>
                <p className="footer-description">
                  A digital platform to track investments and energy access across Africa.
                </p>
              </div>
            </div>
          </div>
          <div className="footer-links">
            <div className="footer-column">
              <h4 className="footer-column-title">Quick Links</h4>
              <Link to="/about" className="footer-link">About the Tracker</Link>
              <Link to="/methodology" className="footer-link">Methodology</Link>
              <Link to="/country-energy-profile" className="footer-link">Country Energy Profile</Link>
              <Link to="/projects" className="footer-link">Projects</Link>
              <Link to="/contact-us" className="footer-link">Contact Us</Link>
            </div>
            <div className="footer-column">
              <h4 className="footer-column-title">Partners</h4>
              <Link 
                to="/about#vasudha-foundation" 
                className="footer-link"
                onClick={(e) => handlePartnerLinkClick(e, '#vasudha-foundation')}
              >
                Vasudha Foundation USA
              </Link>
              <Link 
                to="/about#access-coalition" 
                className="footer-link"
                onClick={(e) => handlePartnerLinkClick(e, '#access-coalition')}
              >
                ACCESS Coalition
              </Link>
              <Link 
                to="/about#steer" 
                className="footer-link"
                onClick={(e) => handlePartnerLinkClick(e, '#steer')}
              >
                STEER
              </Link>
              <Link 
                to="/about#vasudha-environmental" 
                className="footer-link"
                onClick={(e) => handlePartnerLinkClick(e, '#vasudha-environmental')}
              >
                Vasudha Environmental Services
              </Link>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="bottom-footer-container">
          <div className="footer-bottom">
            <div className="footer-bottom-left">
              <p>© 2025 Africa Energy Access Trends. All rights reserved.</p>
            </div>
            <div className="footer-bottom-center">
              <p>Developed and maintained by <a target="_blank" href="https://vistaardigital.com/" className="footer-link">Vistaar Digital</a>.</p>
            </div>
            <div className="footer-bottom-right">
              <a href="#" className="footer-link">Privacy Policy</a>
              <span className="footer-separator">|</span>
              <a href="#" className="footer-link">Terms and Services</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;